export default [
  config => {
    config.headers.Brand = 'sdb_web'
    return config
  },
  error => {
    console.log(error) // for debug
    Promise.reject(error)
  },
]
